// @flow
// @jsx h

import { h, Component } from "preact";
import { Text } from "preact-i18n";

import styles from "./StripeError.scss";
import { CancelCircleIcon, ValidCircleIcon } from "elc-icons";

/**
 * Stripe charge error stateless functional Component
 */

type StripeErrorProps = {
  changeLoadingState?:any,
  config?:WidgetConfig,
  code?: string,
  message?: string
};

export default class StripeError extends Component<StripeErrorProps> {
  componentDidMount () {
    if(this.props.changeLoadingState){
      this.props.changeLoadingState();
    }
    const { Id } = this.props;
  }
  render({config, code, message, Id}) {
    console.log("code", code)
    return (
      <div>
        {code && (
          <div class={styles.stripeError}>
              <span>
                <CancelCircleIcon color="#f04d52" />
              </span>
              <h3>
              <Text id="stripe.charge.failed">Erreur de paiement</Text>
              </h3>
          {code === "processing_error" ? (
            <p><Text id="stripe.charge.error.processingError">{message}</Text></p>
          ): (
            <p> <Text id="stripe.charge.error.unexpected">
                Unexpected charge error.
              </Text></p>
          )}
          <p>
              <Text id="stripe.charge.checkCard">
                Vérifiez vos coordonnées bancaires ou contactez votre banque.
              </Text>
          </p>
        </div>
        )}

        {Id && (
            <div class={styles.stripeTraitement}>
            <span>
              <ValidCircleIcon color="#1bd182" />
            </span>
              <h3>
                <Text id="stripe.charge.error.errorHandlingTitle">Traitement en cours</Text>
              </h3>
              <p>
                <Text id="stripe.charge.error.errorHandling">
                Votre paiement est en cours de traitement. Il est possible que vous recevrez votre mail de confirmation de réservation avec du retard.
                </Text>
              </p>
            </div>
          ) }

    </div>
    );
  }
}



